<!--
 * @Author: zst
 * @Date: 2021-06-30 11:20:59
 * @LastEditTime: 2021-07-20 14:27:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fe-purchase\components\import-content\import-content.vue
-->
<template>
  <div class="import-content">
    <!--选择上传方式  根据类型选择-->
    <div v-show="active == 1 && importSel">
      <slot name="selUpload"></slot>
    </div>
    <!-- 上传 -->
    <div v-show="importSel ? active == 2 : active == 1">
      <slot name="upload"></slot>
    </div>
    <!-- 预览 -->
    <div v-show="importSel ? active == 3 : active == 2">
      <slot name="view"></slot>
    </div>
    <!-- 保存成功 -->
    <div v-show="importSel ? active == 4 : active == 3">
      <slot name="complete"></slot>
    </div>
    <!-- 操作按钮 -->
    <slot name="button">
      <div class="import-content-btn-group">
        <el-button
          class="button"
          @click="handleLeftButton"
        >{{ leftButtonText }}</el-button>
        <el-button
          class="button"
          type="primary"
          @click="handleRightButton"
        >{{ rightButtonText }}</el-button>
        <slot name="checkbox"></slot>
      </div>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'import-content',
    props: {
      leftButtonText: {
        type: String,
        default: '取消'
      },
      rightButtonText: {
        type: String,
        default: '下一步'
      },
      importSel: {
        type: Boolean,
        default: false
      },
      active: {
        type: Number,
        default: 1
      }
    },
    created () {
      console.log(this.$parent)
    },
    methods: {
      handleLeftButton () {
        this.$emit('handleLeftButton')
      },
      handleRightButton () {
        this.$emit('handleRightButton')
      }
    }
  }
</script>

<style lang="scss">
.import-content {
  .import-content-btn-group {
    text-align: center;
    margin-top: 50px;
    .button {
      width: 130px;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 400;
      padding: 12px 10px;
      &+.button {
        margin-left: 20px;
      }
    }
    .checkbox {
      margin-left: 20px;
    }
  }
  .el-button+.el-button{
    margin-left: 20px;
  }
}

</style>
